module.exports = __webpack_public_path__ + "img/guide.8610666a.png";